import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledProjects,
  StyledNavigation,
  StyledElements,
  StyledTitlePal,
  StyleEditIcon
} from './style';

import Carousel from '../Carousel';
import ItemsProjects from '../ItemsProjects';

import { Pencil } from '../../../../assets/images/index';

const GalleryPager = ({ activePage }) => (
  <StyledNavigation>
    <StyledElements activePage={activePage} />
    <StyledElements />
    <StyledElements />
  </StyledNavigation>
);

const PreviousButton = () => null;
const NextButton = () => null;

const Projects = ({ className, dataProjects, onEditMode }) => (
  <div className={className}>
    <StyledTitlePal>
      Participo en estos proyectos
      {onEditMode && <StyleEditIcon svg={Pencil} size="m" color="dark" hover />}
    </StyledTitlePal>
    <StyledProjects>
      <Carousel
        previousButton={PreviousButton}
        nextButton={NextButton}
        paginator={GalleryPager}
      >
        {dataProjects.map(item => (
          <ItemsProjects
            key={`${item.title + item.id}`}
            id={item.id}
            imgSrc={item.imgSrc}
            title={item.title}
            text={item.text}
          />
        ))}
      </Carousel>
    </StyledProjects>
  </div>
);

Projects.propTypes = {
  className: PropTypes.string,
  dataProjects: PropTypes.arrayOf(
    PropTypes.shape({
      imgSrc: PropTypes.string,
      title: PropTypes.string,
      text: PropTypes.string
    })
  ),
  onEditMode: PropTypes.bool
};

export default Projects;
